import { colors } from '../../../../constants';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: colors.dark,
    width: 'auto',
    minWidth: '100px',
  },
  text: {
    color: '#ffffff',
    marginRight: '4px',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing.unit * 2,
    flexWrap: 'wrap',
    gap: '8px',
  },
  formRow: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    marginBottom: theme.spacing.unit * 2,
  },
  formField: {
    flex: '1 1 220px',
  },
  storesBox: {
    maxHeight: '160px',
    overflowY: 'auto',
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 2,
  },
});

export default styles;
